import { Component, computed, input, output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { SynAlertComponent, SynIconComponent } from '@synergy-design-system/angular';

@Component({
  selector: 'app-inline-notification',
  template: ` <syn-alert
    @transitionTrigger
    [variant]="variant()"
    [open]="active()"
    [closable]="closeable()"
    (synHideEvent)="onClose.emit()"
  >
    <syn-icon slot="icon" [name]="icon()"></syn-icon>
    <ng-content></ng-content>
  </syn-alert>`,
  styles: [],
  animations: [
    trigger('transitionTrigger', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scaleY(0)', transformOrigin: '50% 0' }),
        animate('400ms ease-in-out', style({ opacity: 1, transform: 'scaleY(1)' })),
      ]),
      transition(':leave', [animate('400ms', style({ opacity: 0 }))]),
    ]),
  ],
  imports: [SynAlertComponent, SynIconComponent],
})
export class InlineNotificationComponent {
  active = input(true);
  variant = input<'primary' | 'success' | 'neutral' | 'warning' | 'danger'>('primary');
  closeable = input(true);
  animated = input(true);
  onClose = output();

  icon = computed(() => {
    switch (this.variant()) {
      case 'primary':
        return 'info';
      case 'success':
        return 'check';
      case 'neutral':
        return 'info';
      case 'warning':
        return ' warning';
      case 'danger':
        return 'error';
      default:
        return 'info';
    }
  });
}
